import type { ReactNode } from 'react'

interface ChartCardProps {
  readonly title: string
  readonly description?: string
  readonly className?: string
  readonly children: ReactNode
}

/**
 * Rahmen für ein Diagramm.
 *
 * Der Titel benennt die Serie. Deshalb braucht ein Diagramm mit nur einer
 * Serie keine eigene Legende, das wäre doppelt.
 */
export function ChartCard({
  title,
  description,
  className = '',
  children,
}: ChartCardProps): ReactNode {
  return (
    <section
      className={`rounded-lg border border-slate-200 bg-white p-4 dark:border-slate-700 dark:bg-slate-800 ${className}`}
    >
      <h2 className="text-sm font-semibold text-slate-900 dark:text-slate-100">{title}</h2>
      {description !== undefined && (
        <p className="mt-0.5 mb-4 text-xs text-slate-500 dark:text-slate-400">{description}</p>
      )}
      <div className={description === undefined ? 'mt-4' : ''}>{children}</div>
    </section>
  )
}
